import { Component, OnInit, OnDestroy } from '@angular/core';
import { DeviceService } from '../../services/device.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-notify',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxPaginationModule],
  templateUrl: './notify.component.html',
  styleUrl: './notify.component.css',
})
export class NotifyComponent implements OnInit {
  public consumerId: string = '';
  public searchTermInvalid: boolean = false;
  public device: any = null;
  commissionDate: string = '';
  formattedModifiedDate: string = '';
  public cmds: any = [];
  public zones: any = [];
  public limit: number = 5;
  public page: number = 1;
  public totalRows: number = 0;
  public keyword: string = '';
  public filterinfo: any;
  public selectedGroup: any = 'all';
  public sortOrder: string = 'DESC';
  public sortColumn: string = 'cmd_sent_date';
  public time: Boolean = false;
  public reverseflow: Boolean = false;
  public meter: string = '';
  public interval: string = '';
  public time_zone: String = Intl.DateTimeFormat().resolvedOptions().timeZone;

  constructor(
    public deviceService: DeviceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.InitFilterinfo();
    this.getAllZones();
    this.getAllCmds();
  }
  InitFilterinfo() {
    this.filterinfo = {
      keyword: '',
      page: 1,
      limit: 5,
      time_zone: this.time_zone,
    };
  }
  getDeviceId(keyword: string) {
    this.spinner.show();
    keyword = keyword.trim();
    this.Search();
    this.deviceService.searchDeviceById(keyword).subscribe(
      (response) => {
        let data = response.data.deviceInfo;
        this.device = data;
        if (this.device.modified_on) {
          const modifiedDate = new Date(this.device.modified_on);
          this.formattedModifiedDate = modifiedDate
            .toLocaleDateString('en-GB')
            .replace(/\//g, '-');
        }
        if (this.device.commission_date) {
          const commissionDate = new Date(this.device.commission_date);
          this.commissionDate = commissionDate
            .toLocaleDateString('en-GB')
            .replace(/\//g, '-');
        }
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Notify Command');
        this.resetDevice();
        console.log(error.error.message);
        this.spinner.hide();
      }
    );
  }
  resetDevice() {
    this.commissionDate = '';
    this.device = null;
    this.formattedModifiedDate = '';
  }
  pageChangeEvent(event: number) {
    this.page = event;
    this.getAllCmds();
  }
  getAllCmds() {
    this.keyword = this.keyword.trim();
    if (this.selectedGroup != 'all') {
      this.filterinfo.group = this.selectedGroup;
      this.filterinfo.keyword = this.keyword;
      this.filterinfo.time_zone = this.time_zone;
    } else {
      this.filterinfo = {
        keyword: this.keyword,
        page: this.page,
        limit: this.limit,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
        time_zone: this.time_zone,
      };
    }
    this.deviceService.getAllCmds(this.filterinfo).subscribe((response) => {
      this.cmds = response.data.cmds;
    });
  }
  Search() {
    this.page = 1;
    this.getAllCmds();
  }
  Clear() {
    this.keyword = '';
    this.page = 1;
    this.sortColumn = 'cmd_sent_date';
    this.sortOrder = 'DESC';
    this.selectedGroup = 'all';
    this.resetDevice();
    this.getAllCmds();
  }
  getAllZones() {
    this.deviceService.getAllZones().subscribe(
      (response) => {
        this.zones = response.data.zones;
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Notify Command');
        console.log('error message: ', error.error.message);
        this.spinner.hide();
      }
    );
  }
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortColumn = column;
      this.sortOrder = 'ASC';
    }
    this.getAllCmds();
  }
  downlink() {
    if (!this.device) {
        this.toastr.error('Select a device to send downlink', 'Notify Command');
        return false;
    }

    let object = {
        update_current_reading: false,
        meter_reading: 0,
        update_reporting_interval: false,
        reporting_interval: 0,
        update_module_time: false,
        reset_reverse_flow: false,
    };

    // Validate and set meter reading
    if (this.meter !== '') {
        const meterValue = parseInt(this.meter, 10);
        if (isNaN(meterValue) || meterValue < 0) {
            this.toastr.error('Invalid Meter Reading. Enter a positive number.', 'Notify Command');
            return false;
        }
        object.update_current_reading = true;
        object.meter_reading = meterValue;
    }

    // Validate and set reporting interval
    if (this.interval !== '') {
        const intervalValue = parseInt(this.interval, 10);
        if (isNaN(intervalValue) || intervalValue <= 0) {
            this.toastr.error('Invalid Reporting Interval. Enter a positive number.', 'Notify Command');
            return false;
        }
        object.update_reporting_interval = true;
        object.reporting_interval = intervalValue;
    }

    // Set module time flag if checkbox is true
    if (this.time === true) {
        object.update_module_time = true;
    }

    // Set reset reverse flow flag if checkbox is true
    if (this.reverseflow === true) {
        object.reset_reverse_flow = true;
    }

    // Ensure at least one operation is selected
    if (!object.update_current_reading && !object.update_reporting_interval && 
        !object.update_module_time && !object.reset_reverse_flow) {
        this.toastr.error('No Data for downlink', 'Notify Command');
        return false;
    }

    // Send the downlink message
    this.deviceService.downlink(this.device.dev_eui, object).subscribe(
        (response) => {
            this.toastr.success(response.data, 'Notify Command');
            this.resetDevice();
            this.formReset()
        },
        (error) => {
            this.toastr.error('Failed to send downlink', 'Notify Command');
        }
    );

    return true;
}
  formReset() {
    this.meter = '';
    this.interval = '';
    this.time = false;
    this.reverseflow = false;
  }

  exportCmds() {
    this.keyword = this.keyword.trim();
    if (this.selectedGroup != 'all') {
      this.filterinfo.group = this.selectedGroup;
      this.filterinfo.keyword = this.keyword;
      this.filterinfo.time_zone = this.time_zone;
    } else {
      this.filterinfo = {
        keyword: this.keyword,
        page: this.page,
        limit: this.limit,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
        time_zone: this.time_zone,
      };
    }
    this.deviceService.exportCmds(this.filterinfo).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], {
          //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          type: 'application/octet-stream',
        });
        saveAs(blob, 'Cmds.xlsx');
        this.toastr.success('Cmds exported successfully', 'Notify Command');
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Notify Command');
        console.log('error message: ', error.error.message);
        this.spinner.hide();
      }
    );
  }
}
